"use strict";

import Toolbox from "./toolbox";

export default function () {

	const textToggleElements = document.querySelectorAll("*[data-join-text], *[data-login-text]");

	function disableEnableForm (mode = true) {
		const formArea = document.querySelector(".form-area");
		if (formArea) {
			for (const formElement of formArea.querySelectorAll("button[type=submit]")) {
				formElement.disabled = mode;
			}
		}
	}

	function toggleTexts(mode = "login") {
		for (const element of textToggleElements) {
			if (mode === "login") {
				const loginText = element.dataset.loginText;
				if (loginText) {
					element.textContent = loginText;
				}
			} else if (mode === "join") {
				const loginText = element.dataset.joinText;
				if (loginText) {
					element.textContent = loginText;
				}
			}
		}
	}

	// Handle login form submit.
	const loginform = document.querySelector(".klubi-login-form");
	if (loginform) {
		loginform.addEventListener("submit", (e) => {
			e.preventDefault();

			const loginForm = e.target;
			if (loginForm.checkValidity()) {
				//const cmToken = loginForm.querySelector("input[name=cm_token]");
				disableEnableForm(true);
				const loginButton = loginForm.querySelector("button[name=login]");
				//const loginButtonText = loginButton.textContent;
				loginButton.textContent = "Kirjaudutaan...";
				loginForm.submit();
				/*
				Toolbox.getToken(function (token) {
					cmToken.value = token;
					loginForm.submit();
				}, () => {
					loginButton.textContent = "Tapahtui virhe. Lataa sivu uudelleen.";
					loginButton.style.color = "black";
					setTimeout(() => {
						loginButton.style.color = "";
						loginButton.textContent = loginButtonText;
						disableEnableForm(false);
					}, 3000);
				});*/
			}
		});
	}

	// Handle registration form submit.
	const registrationform = document.querySelector(".klubi-registration-form");
	if (registrationform) {
		registrationform.addEventListener("submit", (e) => {
			e.preventDefault();
			const registrationForm = e.target;
			if (registrationForm.checkValidity()) {
				const token = registrationForm.querySelector("input[name=token]");
				disableEnableForm(true);
				const registrationButton = registrationForm.querySelector("button[name=registration]");
				const registrationButtonText = registrationButton.textContent;
				registrationButton.textContent = "Odota...";
				Toolbox.getToken((StageToken) => {
					token.value = StageToken;
					registrationForm.submit();
				}, () => {
					registrationButton.textContent = "Tapahtui virhe. Lataa sivu uudelleen.";
					registrationButton.style.color = "black";
					setTimeout(() => {
						registrationButton.style.color = "";
						registrationButton.textContent = registrationButtonText;
						disableEnableForm(false);
					}, 3000);
				});
			}
		});
	}

	// If regsitration is already visible.
	const formWrapper = document.querySelector(".join-budgetsport-klubi .form-area .content-wrapper");
	if (formWrapper) {
		if (formWrapper.classList.contains("registration-visible")) {
			const height = formWrapper.querySelector(".klubi-registration").offsetHeight;
			formWrapper.style.minHeight = height + "px";
		}
	}

	// Flip between login and registration form.
	const kulbiFormChanger = document.querySelectorAll(".kulbi-form-changer");
	for (const kulbiFormFlipper of kulbiFormChanger) {
		kulbiFormFlipper.addEventListener("click", (e) => {

			document.activeElement.blur();
			// Instantly clears validator.
			document.activeElement.blur();

			if (formWrapper) {

				if (formWrapper.classList.toggle("registration-visible")) {
					const firstInput = formWrapper.querySelector(".klubi-registration input:not([type=hidden])");
					if (firstInput) {
						firstInput.focus();
					}
					toggleTexts("join");

				} else {
					const height = formWrapper.querySelector(".klubi-registration").offsetHeight;

					formWrapper.style.minHeight = height + "px";

					setTimeout(() => {
						formWrapper.style.minHeight = "";
					}, parseFloat(window.getComputedStyle(formWrapper).getPropertyValue("transition-duration") || 0.5) * 1000);

					const firstInput = formWrapper.querySelector(".klubi-login input:not([type=hidden])");
					if (firstInput) {
						firstInput.focus();
					}
					toggleTexts("login");
				}
			}

		});
	}
}